<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="page-header">
        <img [src]="getCoverUrl()" alt="company-image">
      </div>
    </div>

    <div class="col-12">
      <div class="page-description">
        <div class="company-title">
          <div class="company-title-left">
            <h1>
              {{ companyProfile?.name || '-' }}
              <span
                *ngIf="companyProfile?.verifiedBadge && companyProfile?.verificationStatus === 'APPROVED'"
                class="verified-badge"
                [title]="'companyProfile.verifiedCompany' | translate"
              >
                <i class="bi bi-patch-check-fill"></i>
                <span class="verified-text">Verified</span>
              </span>
            </h1>
            <p class="mt-2">{{ companyProfile?.industryType || '-' }}</p>
          </div>
          <div class="company-title-rating">
            <i class="bi bi-star-fill"></i>
            <div class="rating-text">
              <span class="rating-val">{{ companyProfile?.rate || '-' }}</span>
              <span class="rating-sub">{{ 'companyProfile.basedOn' | translate }} {{ companyProfile?.rateCount || 0 }} {{ 'companyProfile.reviews' | translate }}</span>
            </div>
          </div>
        </div>

        <ul class="nav-tabs">
          <li [class.active]="activeTab === 'overview'" (click)="setActiveTab('overview')">
            {{ 'companyProfile.overview' | translate }}
          </li>
          <li [class.active]="activeTab === 'jobs'" (click)="setActiveTab('jobs')">
            {{ 'companyProfile.jobOpportunities' | translate }}
          </li>
        </ul>

        <div class="wrapper">
          <app-company-overview
            *ngIf="activeTab === 'overview'"
            [companyProfile]="companyProfile"
          ></app-company-overview>
          <app-company-joblist
            *ngIf="activeTab === 'jobs'"
            [companyId]="companyId">
          </app-company-joblist>
        </div>
      </div>
    </div>
  </div>
</div>